export const categories = [
  { id: 'summer-camps', name: 'Summer Camps', color: 'bg-amber-100 text-amber-700' },
  { id: 'birthday-venues', name: 'Birthday Party Venues', color: 'bg-pink-100 text-pink-700' },
  { id: 'photographers', name: 'Photographers', color: 'bg-purple-100 text-purple-700' },
  { id: 'kids-activities', name: 'Kids Activities', color: 'bg-blue-100 text-blue-700' },
  { id: 'mom-businesses', name: 'Mom Businesses', color: 'bg-rose-100 text-rose-700' },
  { id: 'fitness', name: 'Fitness', color: 'bg-green-100 text-green-700' },
  { id: 'hair-beauty', name: 'Hair & Beauty', color: 'bg-indigo-100 text-indigo-700' },
  { id: 'tutors', name: 'Tutors', color: 'bg-teal-100 text-teal-700' },
  { id: 'doctors', name: 'Doctors', color: 'bg-cyan-100 text-cyan-700' },
  { id: 'party-vendors', name: 'Party Vendors', color: 'bg-orange-100 text-orange-700' }
];

export const businesses = [
  {
    id: 'camp-1',
    name: 'Adventure Kids Summer Camp',
    category: 'summer-camps',
    description: 'Week-long outdoor adventure camp for kids ages 5-12. Activities include hiking, nature exploration, arts & crafts, and team-building games. Experienced counselors and small group sizes ensure personalized attention.',
    location: 'Sugar Hill, GA',
    photos: [
      'https://public.readdy.ai/ai/img_res/316d29faee6f0b24d41176a5ccd6494b.jpg',
      'https://readdy.ai/api/search-image?query=kids%20doing%20arts%20and%20crafts%20at%20summer%20camp%20colorful%20paint%20and%20materials%20on%20tables%20smiling%20children%20creating%20projects%20indoor%20camp%20activity%20room&width=800&height=600&seq=camp1b&orientation=landscape',
      'https://readdy.ai/api/search-image?query=children%20hiking%20on%20nature%20trail%20with%20backpacks%20and%20camp%20counselor%20beautiful%20outdoor%20scenery%20trees%20and%20sunshine%20adventure%20camp%20setting&width=800&height=600&seq=camp1c&orientation=landscape'
    ],
    website: 'https://adventurekidscamp.com',
    socialLinks: {
      instagram: 'https://instagram.com/adventurekidscamp',
      facebook: 'https://facebook.com/adventurekidscamp'
    },
    averageRating: 4.8,
    reviewCount: 24,
    reviews: [
      {
        reviewerName: 'Sarah M.',
        rating: 5,
        comment: 'My daughter had the best week ever! The counselors were amazing and she came home every day with stories about her adventures. Already signed up for next summer!',
        date: '2024-08-15'
      },
      {
        reviewerName: 'Jennifer K.',
        rating: 5,
        comment: 'Highly recommend! Great balance of outdoor activities and creative time. My son made new friends and learned so much about nature.',
        date: '2024-07-28'
      },
      {
        reviewerName: 'Amanda R.',
        rating: 4,
        comment: 'Wonderful camp experience. Only wish the days were a bit longer, but overall fantastic program.',
        date: '2024-07-10'
      }
    ],
    isPartner: true,
    memberDiscount: '15% off first week for Mommy Mingle members'
  },
  {
    id: 'camp-2',
    name: 'STEM Explorers Camp',
    category: 'summer-camps',
    description: 'Science, technology, engineering, and math focused camp for curious minds ages 7-14. Hands-on experiments, robotics, coding workshops, and science challenges. Perfect for kids who love to learn and create.',
    location: 'Buford, GA',
    photos: [
      'https://readdy.ai/api/search-image?query=children%20building%20robots%20and%20doing%20science%20experiments%20at%20STEM%20camp%20colorful%20lab%20equipment%20computers%20and%20technology%20bright%20modern%20classroom%20setting%20engaged%20students&width=800&height=600&seq=camp2a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=kids%20coding%20on%20computers%20at%20technology%20summer%20camp%20focused%20students%20with%20laptops%20and%20screens%20modern%20bright%20classroom%20with%20educational%20posters&width=800&height=600&seq=camp2b&orientation=landscape'
    ],
    website: 'https://stemexplorerscamp.com',
    socialLinks: {
      instagram: 'https://instagram.com/stemexplorers',
      facebook: 'https://facebook.com/stemexplorerscamp'
    },
    averageRating: 4.9,
    reviewCount: 31,
    reviews: [
      {
        reviewerName: 'Michelle T.',
        rating: 5,
        comment: 'My son is obsessed with this camp! He built his first robot and learned basic coding. The instructors are knowledgeable and patient.',
        date: '2024-08-20'
      },
      {
        reviewerName: 'Lisa P.',
        rating: 5,
        comment: 'Best investment in my daughter\'s education. She\'s now talking about becoming an engineer!',
        date: '2024-08-05'
      },
      {
        reviewerName: 'Karen W.',
        rating: 4,
        comment: 'Great program with excellent curriculum. My only suggestion would be more outdoor breaks.',
        date: '2024-07-22'
      }
    ],
    isPartner: false,
    memberDiscount: ''
  },
  {
    id: 'camp-3',
    name: 'Creative Arts Summer Studio',
    category: 'summer-camps',
    description: 'Unleash your child\'s creativity with painting, drawing, sculpture, music, and drama. Professional artists guide students through various mediums and techniques. Ages 6-13 welcome.',
    location: 'Suwanee, GA',
    photos: [
      'https://readdy.ai/api/search-image?query=children%20painting%20and%20creating%20art%20at%20summer%20camp%20colorful%20artwork%20on%20easels%20bright%20art%20studio%20with%20paint%20supplies%20happy%20creative%20kids&width=800&height=600&seq=camp3a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=kids%20doing%20drama%20and%20theater%20activities%20at%20arts%20camp%20stage%20with%20costumes%20and%20props%20children%20performing%20and%20having%20fun%20creative%20studio%20setting&width=800&height=600&seq=camp3b&orientation=landscape'
    ],
    website: 'https://creativeartscamp.com',
    socialLinks: {
      instagram: 'https://instagram.com/creativeartscamp',
      facebook: 'https://facebook.com/creativeartscamp'
    },
    averageRating: 4.7,
    reviewCount: 19,
    reviews: [
      {
        reviewerName: 'Emily S.',
        rating: 5,
        comment: 'My daughter discovered her love for painting here. The instructors are so encouraging and talented.',
        date: '2024-08-12'
      },
      {
        reviewerName: 'Rachel B.',
        rating: 4,
        comment: 'Wonderful creative environment. My son came home with beautiful artwork every week.',
        date: '2024-07-30'
      }
    ],
    isPartner: true,
    memberDiscount: '10% off all summer sessions'
  },
  {
    id: 'venue-1',
    name: 'Bounce & Play Party Zone',
    category: 'birthday-venues',
    description: 'Ultimate indoor party destination with inflatable bounce houses, obstacle courses, and arcade games. Party packages include private party room, decorations, and dedicated party host. Perfect for ages 2-12.',
    location: 'Lawrenceville, GA',
    photos: [
      'https://readdy.ai/api/search-image?query=colorful%20indoor%20bounce%20house%20party%20venue%20with%20inflatable%20slides%20and%20obstacle%20courses%20bright%20lights%20balloons%20and%20decorations%20children%20playing%20and%20having%20fun&width=800&height=600&seq=venue1a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=birthday%20party%20room%20with%20decorated%20tables%20balloons%20and%20party%20supplies%20colorful%20festive%20setup%20for%20kids%20party%20celebration&width=800&height=600&seq=venue1b&orientation=landscape'
    ],
    website: 'https://bounceandplayzone.com',
    socialLinks: {
      instagram: 'https://instagram.com/bounceandplay',
      facebook: 'https://facebook.com/bounceandplayzone'
    },
    averageRating: 4.6,
    reviewCount: 42,
    reviews: [
      {
        reviewerName: 'Jessica L.',
        rating: 5,
        comment: 'Best party venue ever! The staff handled everything and the kids had a blast. So stress-free for parents!',
        date: '2024-06-15'
      },
      {
        reviewerName: 'Megan H.',
        rating: 4,
        comment: 'Great facility and the kids loved it. Only downside was it got pretty loud with multiple parties.',
        date: '2024-05-28'
      },
      {
        reviewerName: 'Nicole D.',
        rating: 5,
        comment: 'Hosted my son\'s 6th birthday here and it was perfect. The party host was amazing!',
        date: '2024-04-20'
      }
    ],
    isPartner: true,
    memberDiscount: 'Free party host upgrade for members'
  },
  {
    id: 'venue-2',
    name: 'Little Chefs Cooking Studio',
    category: 'birthday-venues',
    description: 'Unique cooking party experience where kids become chefs for the day. Age-appropriate recipes, all ingredients provided, and kids take home what they make. Perfect for budding foodies ages 5-14.',
    location: 'Sugar Hill, GA',
    photos: [
      'https://readdy.ai/api/search-image?query=children%20wearing%20chef%20hats%20cooking%20and%20baking%20in%20bright%20modern%20kitchen%20studio%20colorful%20ingredients%20and%20cooking%20tools%20kids%20having%20fun%20making%20food&width=800&height=600&seq=venue2a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=kids%20decorating%20cupcakes%20and%20cookies%20at%20cooking%20party%20bright%20kitchen%20with%20colorful%20frosting%20and%20sprinkles%20happy%20children%20creating%20treats&width=800&height=600&seq=venue2b&orientation=landscape'
    ],
    website: 'https://littlechefsstudio.com',
    socialLinks: {
      instagram: 'https://instagram.com/littlechefsstudio',
      facebook: 'https://facebook.com/littlechefsstudio'
    },
    averageRating: 4.9,
    reviewCount: 28,
    reviews: [
      {
        reviewerName: 'Christina M.',
        rating: 5,
        comment: 'Such a unique party idea! My daughter and her friends had so much fun making their own pizzas. Highly recommend!',
        date: '2024-06-08'
      },
      {
        reviewerName: 'Ashley W.',
        rating: 5,
        comment: 'Best party we\'ve ever thrown! The instructors were patient and the kids learned real cooking skills.',
        date: '2024-05-15'
      }
    ],
    isPartner: false,
    memberDiscount: ''
  },
  {
    id: 'venue-3',
    name: 'Safari Adventure Park',
    category: 'birthday-venues',
    description: 'Outdoor adventure park with zip lines, climbing walls, nature trails, and animal encounters. Party packages include guided activities and picnic area. Great for active kids ages 6 and up.',
    location: 'Duluth, GA',
    photos: [
      'https://readdy.ai/api/search-image?query=outdoor%20adventure%20park%20with%20zip%20lines%20and%20climbing%20walls%20children%20having%20fun%20in%20nature%20setting%20trees%20and%20sunshine%20active%20kids%20playing&width=800&height=600&seq=venue3a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=children%20meeting%20friendly%20animals%20at%20petting%20zoo%20outdoor%20park%20setting%20happy%20kids%20with%20goats%20and%20rabbits%20sunny%20day&width=800&height=600&seq=venue3b&orientation=landscape'
    ],
    website: 'https://safariadventurepark.com',
    socialLinks: {
      instagram: 'https://instagram.com/safariadventure',
      facebook: 'https://facebook.com/safariadventurepark'
    },
    averageRating: 4.7,
    reviewCount: 35,
    reviews: [
      {
        reviewerName: 'Stephanie R.',
        rating: 5,
        comment: 'Amazing outdoor party venue! The kids loved the zip line and the animal encounters were a huge hit.',
        date: '2024-06-22'
      },
      {
        reviewerName: 'Laura K.',
        rating: 4,
        comment: 'Great for active kids. Just be prepared for weather - have a backup plan for rain.',
        date: '2024-05-10'
      }
    ],
    isPartner: true,
    memberDiscount: '20% off party packages'
  },
  {
    id: 'photo-1',
    name: 'Moments by Melissa Photography',
    category: 'photographers',
    description: 'Specializing in family portraits, newborn sessions, and milestone photography. Natural light photographer with a warm, candid style. Serving Gwinnett County families for over 8 years.',
    location: 'Sugar Hill, GA',
    photos: [
      'https://readdy.ai/api/search-image?query=beautiful%20family%20portrait%20outdoors%20with%20golden%20hour%20lighting%20mom%20dad%20and%20children%20smiling%20naturally%20warm%20candid%20photography%20style%20soft%20focus%20background&width=800&height=600&seq=photo1a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=adorable%20newborn%20baby%20photography%20session%20soft%20blankets%20and%20props%20peaceful%20sleeping%20infant%20professional%20studio%20lighting%20warm%20tones&width=800&height=600&seq=photo1b&orientation=landscape'
    ],
    website: 'https://momentsbymelissa.com',
    socialLinks: {
      instagram: 'https://instagram.com/momentsbymelissa',
      facebook: 'https://facebook.com/momentsbymelissaphoto'
    },
    averageRating: 5.0,
    reviewCount: 47,
    reviews: [
      {
        reviewerName: 'Brittany J.',
        rating: 5,
        comment: 'Melissa is absolutely amazing! She captured our family perfectly and made the whole session fun and relaxed.',
        date: '2024-06-30'
      },
      {
        reviewerName: 'Danielle P.',
        rating: 5,
        comment: 'Best newborn photographer in Gwinnett! So patient and gentle with our baby. The photos are stunning.',
        date: '2024-06-18'
      },
      {
        reviewerName: 'Heather G.',
        rating: 5,
        comment: 'We\'ve used Melissa for years and she never disappoints. Highly recommend for family photos!',
        date: '2024-05-25'
      }
    ],
    isPartner: true,
    memberDiscount: '$50 off session fee'
  },
  {
    id: 'photo-2',
    name: 'Sweet Pea Photography',
    category: 'photographers',
    description: 'Whimsical and creative children\'s photography. Specializing in cake smash sessions, first birthdays, and playful family shoots. Fun props and themed setups available.',
    location: 'Buford, GA',
    photos: [
      'https://readdy.ai/api/search-image?query=adorable%20baby%20cake%20smash%20photography%20session%20colorful%20balloons%20and%20decorations%20messy%20happy%20toddler%20with%20birthday%20cake%20whimsical%20playful%20setup&width=800&height=600&seq=photo2a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=creative%20children%20portrait%20photography%20with%20fun%20props%20and%20colorful%20backgrounds%20happy%20kids%20playing%20and%20laughing%20whimsical%20playful%20style&width=800&height=600&seq=photo2b&orientation=landscape'
    ],
    website: 'https://sweetpeaphoto.com',
    socialLinks: {
      instagram: 'https://instagram.com/sweetpeaphoto',
      facebook: 'https://facebook.com/sweetpeaphotography'
    },
    averageRating: 4.8,
    reviewCount: 33,
    reviews: [
      {
        reviewerName: 'Samantha B.',
        rating: 5,
        comment: 'The cake smash photos are adorable! She captured my daughter\'s personality perfectly.',
        date: '2024-06-12'
      },
      {
        reviewerName: 'Kristen F.',
        rating: 5,
        comment: 'So creative and fun! My kids actually enjoyed the photo session which is a miracle.',
        date: '2024-05-20'
      }
    ],
    isPartner: false,
    memberDiscount: ''
  },
  {
    id: 'photo-3',
    name: 'Legacy Family Portraits',
    category: 'photographers',
    description: 'Classic and timeless family photography. Studio and outdoor sessions available. Specializing in multi-generational family portraits and creating heirloom quality prints.',
    location: 'Suwanee, GA',
    photos: [
      'https://readdy.ai/api/search-image?query=elegant%20classic%20family%20portrait%20with%20multiple%20generations%20grandparents%20parents%20and%20children%20formal%20timeless%20style%20beautiful%20outdoor%20setting&width=800&height=600&seq=photo3a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=professional%20studio%20family%20portrait%20with%20classic%20lighting%20and%20backdrop%20elegant%20timeless%20style%20well-dressed%20family%20smiling&width=800&height=600&seq=photo3b&orientation=landscape'
    ],
    website: 'https://legacyfamilyportraits.com',
    socialLinks: {
      instagram: 'https://instagram.com/legacyfamilyportraits',
      facebook: 'https://facebook.com/legacyfamilyportraits'
    },
    averageRating: 4.9,
    reviewCount: 29,
    reviews: [
      {
        reviewerName: 'Patricia S.',
        rating: 5,
        comment: 'Beautiful work! We had four generations in our photo and it turned out perfect.',
        date: '2024-06-05'
      },
      {
        reviewerName: 'Jennifer M.',
        rating: 5,
        comment: 'Professional and timeless. These photos will be treasured for generations.',
        date: '2024-05-18'
      }
    ],
    isPartner: true,
    memberDiscount: 'Complimentary 8x10 print with session'
  },
  {
    id: 'activity-1',
    name: 'Tumble & Grow Gymnastics',
    category: 'kids-activities',
    description: 'Gymnastics classes for toddlers through teens. Age-appropriate instruction focusing on strength, flexibility, and confidence building. Open gym times and birthday parties available.',
    location: 'Lawrenceville, GA',
    photos: [
      'https://readdy.ai/api/search-image?query=children%20doing%20gymnastics%20in%20bright%20colorful%20gym%20with%20mats%20and%20equipment%20kids%20tumbling%20and%20practicing%20skills%20happy%20active%20children&width=800&height=600&seq=activity1a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=young%20kids%20in%20gymnastics%20class%20with%20instructor%20learning%20balance%20beam%20and%20floor%20exercises%20bright%20gym%20setting%20colorful%20equipment&width=800&height=600&seq=activity1b&orientation=landscape'
    ],
    website: 'https://tumbleandgrow.com',
    socialLinks: {
      instagram: 'https://instagram.com/tumbleandgrow',
      facebook: 'https://facebook.com/tumbleandgrowgym'
    },
    averageRating: 4.7,
    reviewCount: 38,
    reviews: [
      {
        reviewerName: 'Melissa C.',
        rating: 5,
        comment: 'My daughter loves her gymnastics class! The coaches are patient and encouraging.',
        date: '2024-06-25'
      },
      {
        reviewerName: 'Amy T.',
        rating: 4,
        comment: 'Great program for building confidence. My shy daughter has really come out of her shell.',
        date: '2024-06-10'
      },
      {
        reviewerName: 'Katie R.',
        rating: 5,
        comment: 'Clean facility and excellent instruction. Highly recommend!',
        date: '2024-05-28'
      }
    ],
    isPartner: false,
    memberDiscount: ''
  },
  {
    id: 'activity-2',
    name: 'Little Maestros Music School',
    category: 'kids-activities',
    description: 'Music lessons for children ages 3 and up. Piano, guitar, violin, and voice instruction. Group classes and private lessons available. Recitals twice a year.',
    location: 'Sugar Hill, GA',
    photos: [
      'https://readdy.ai/api/search-image?query=children%20learning%20piano%20and%20music%20instruments%20in%20bright%20colorful%20music%20classroom%20young%20students%20with%20teacher%20playing%20keyboards%20happy%20kids&width=800&height=600&seq=activity2a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=kids%20playing%20guitars%20and%20violins%20in%20music%20class%20group%20lesson%20with%20instruments%20colorful%20music%20room%20with%20notes%20and%20posters&width=800&height=600&seq=activity2b&orientation=landscape'
    ],
    website: 'https://littlemaestros.com',
    socialLinks: {
      instagram: 'https://instagram.com/littlemaestros',
      facebook: 'https://facebook.com/littlemaestrosmusic'
    },
    averageRating: 4.9,
    reviewCount: 26,
    reviews: [
      {
        reviewerName: 'Rebecca L.',
        rating: 5,
        comment: 'Wonderful music program! My son has learned so much and actually practices without being asked.',
        date: '2024-06-20'
      },
      {
        reviewerName: 'Maria G.',
        rating: 5,
        comment: 'The teachers are talented musicians and great with kids. Can\'t recommend enough!',
        date: '2024-06-08'
      }
    ],
    isPartner: true,
    memberDiscount: 'First month 25% off'
  },
  {
    id: 'activity-3',
    name: 'Splash & Swim Academy',
    category: 'kids-activities',
    description: 'Year-round swim lessons in heated indoor pool. Infant through adult classes. Small class sizes and certified instructors. Water safety focused curriculum.',
    location: 'Buford, GA',
    photos: [
      'https://readdy.ai/api/search-image?query=children%20learning%20to%20swim%20in%20indoor%20pool%20with%20instructor%20bright%20clean%20facility%20kids%20wearing%20floaties%20and%20goggles%20happy%20swimming%20lessons&width=800&height=600&seq=activity3a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=young%20kids%20in%20swimming%20class%20with%20teacher%20in%20heated%20pool%20colorful%20pool%20toys%20and%20learning%20equipment%20bright%20indoor%20aquatic%20center&width=800&height=600&seq=activity3b&orientation=landscape'
    ],
    website: 'https://splashandswim.com',
    socialLinks: {
      instagram: 'https://instagram.com/splashandswim',
      facebook: 'https://facebook.com/splashandswimacademy'
    },
    averageRating: 4.8,
    reviewCount: 41,
    reviews: [
      {
        reviewerName: 'Tiffany H.',
        rating: 5,
        comment: 'Best swim school! My kids went from scared of water to confident swimmers in just a few months.',
        date: '2024-06-28'
      },
      {
        reviewerName: 'Lauren S.',
        rating: 5,
        comment: 'Clean facility and excellent instructors. The small class sizes make a huge difference.',
        date: '2024-06-15'
      }
    ],
    isPartner: true,
    memberDiscount: 'Free trial class for members'
  },
  {
    id: 'mom-biz-1',
    name: 'Sweet Dreams Baby Sleep Consulting',
    category: 'mom-businesses',
    description: 'Certified sleep consultant helping exhausted parents get their babies sleeping through the night. Personalized sleep plans, phone support, and follow-up included. Founded by local mom of three.',
    location: 'Sugar Hill, GA',
    photos: [
      'https://readdy.ai/api/search-image?query=peaceful%20sleeping%20baby%20in%20cozy%20nursery%20soft%20lighting%20and%20gentle%20colors%20serene%20infant%20sleep%20setting%20comfortable%20crib%20with%20white%20bedding&width=800&height=600&seq=mombiz1a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=mom%20consultant%20working%20with%20parent%20and%20baby%20in%20nursery%20professional%20caring%20atmosphere%20sleep%20training%20session%20warm%20lighting&width=800&height=600&seq=mombiz1b&orientation=landscape'
    ],
    website: 'https://sweetdreamsconsulting.com',
    socialLinks: {
      instagram: 'https://instagram.com/sweetdreamsconsulting',
      facebook: 'https://facebook.com/sweetdreamsbabysleep'
    },
    averageRating: 5.0,
    reviewCount: 52,
    reviews: [
      {
        reviewerName: 'Elizabeth W.',
        rating: 5,
        comment: 'Life changing! Our baby went from waking every 2 hours to sleeping 11 hours straight. Worth every penny!',
        date: '2024-06-22'
      },
      {
        reviewerName: 'Sarah J.',
        rating: 5,
        comment: 'So knowledgeable and supportive. She answered all my questions and the plan actually worked!',
        date: '2024-06-10'
      },
      {
        reviewerName: 'Amanda K.',
        rating: 5,
        comment: 'Best investment we made as new parents. Our whole family is sleeping better now.',
        date: '2024-05-30'
      }
    ],
    isPartner: true,
    memberDiscount: '$75 off sleep consultation package'
  },
  {
    id: 'mom-biz-2',
    name: 'Nourish Meal Prep by Mama',
    category: 'mom-businesses',
    description: 'Healthy meal prep service delivering fresh, family-friendly meals weekly. Accommodates dietary restrictions and picky eaters. Started by a local mom and nutritionist.',
    location: 'Suwanee, GA',
    photos: [
      'https://readdy.ai/api/search-image?query=healthy%20prepared%20meals%20in%20containers%20colorful%20fresh%20vegetables%20and%20proteins%20organized%20meal%20prep%20boxes%20nutritious%20family-friendly%20food&width=800&height=600&seq=mombiz2a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=mom%20preparing%20healthy%20meals%20in%20bright%20kitchen%20fresh%20ingredients%20and%20cooking%20healthy%20family%20dinner%20meal%20prep%20service&width=800&height=600&seq=mombiz2b&orientation=landscape'
    ],
    website: 'https://nourishmealprep.com',
    socialLinks: {
      instagram: 'https://instagram.com/nourishmealprep',
      facebook: 'https://facebook.com/nourishmealprepmama'
    },
    averageRating: 4.8,
    reviewCount: 34,
    reviews: [
      {
        reviewerName: 'Kelly M.',
        rating: 5,
        comment: 'Saves me so much time and my kids actually eat the meals! Delicious and healthy.',
        date: '2024-06-18'
      },
      {
        reviewerName: 'Natalie P.',
        rating: 5,
        comment: 'Game changer for our busy family. The meals are tasty and portion sizes are perfect.',
        date: '2024-06-05'
      }
    ],
    isPartner: false,
    memberDiscount: ''
  },
  {
    id: 'mom-biz-3',
    name: 'Little Sprouts Boutique',
    category: 'mom-businesses',
    description: 'Curated children\'s clothing and accessories boutique. Unique brands you won\'t find in big box stores. Owned by local mom with an eye for style and quality.',
    location: 'Sugar Hill, GA',
    photos: [
      'https://readdy.ai/api/search-image?query=charming%20children%20clothing%20boutique%20interior%20with%20colorful%20kids%20clothes%20on%20racks%20cute%20displays%20and%20accessories%20bright%20inviting%20shop&width=800&height=600&seq=mombiz3a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=adorable%20kids%20fashion%20clothing%20display%20with%20trendy%20outfits%20and%20accessories%20boutique%20style%20presentation%20colorful%20children%20apparel&width=800&height=600&seq=mombiz3b&orientation=landscape'
    ],
    website: 'https://littlesproutsboutique.com',
    socialLinks: {
      instagram: 'https://instagram.com/littlesproutsboutique',
      facebook: 'https://facebook.com/littlesproutsboutique'
    },
    averageRating: 4.9,
    reviewCount: 27,
    reviews: [
      {
        reviewerName: 'Courtney D.',
        rating: 5,
        comment: 'Love this shop! The owner has great taste and the quality is excellent. My go-to for gifts.',
        date: '2024-06-12'
      },
      {
        reviewerName: 'Allison R.',
        rating: 5,
        comment: 'Such cute clothes and the owner is so sweet! Support local moms!',
        date: '2024-05-28'
      }
    ],
    isPartner: true,
    memberDiscount: '10% off all purchases'
  },
  {
    id: 'fitness-1',
    name: 'Stroller Strides Gwinnett',
    category: 'fitness',
    description: 'Outdoor fitness classes designed for moms with strollers. Total body workout while your little one enjoys the ride. Build strength and community. All fitness levels welcome.',
    location: 'Sugar Hill, GA',
    photos: [
      'https://readdy.ai/api/search-image?query=group%20of%20moms%20exercising%20outdoors%20with%20baby%20strollers%20in%20park%20fitness%20class%20women%20working%20out%20together%20sunny%20day%20active%20mothers&width=800&height=600&seq=fitness1a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=moms%20doing%20lunges%20and%20strength%20training%20with%20strollers%20outdoor%20fitness%20class%20in%20park%20active%20women%20exercising%20together&width=800&height=600&seq=fitness1b&orientation=landscape'
    ],
    website: 'https://strollerstridesgwinnett.com',
    socialLinks: {
      instagram: 'https://instagram.com/strollerstridesgwinnett',
      facebook: 'https://facebook.com/strollerstridesgwinnett'
    },
    averageRating: 4.9,
    reviewCount: 45,
    reviews: [
      {
        reviewerName: 'Jamie L.',
        rating: 5,
        comment: 'Love this class! Great workout and I\'ve made so many mom friends. My baby loves it too!',
        date: '2024-06-26'
      },
      {
        reviewerName: 'Erin B.',
        rating: 5,
        comment: 'Perfect for new moms! The instructor modifies exercises for all fitness levels.',
        date: '2024-06-14'
      },
      {
        reviewerName: 'Morgan T.',
        rating: 5,
        comment: 'Best part of my week! Getting fit and socializing at the same time.',
        date: '2024-06-02'
      }
    ],
    isPartner: true,
    memberDiscount: 'First class free for members'
  },
  {
    id: 'fitness-2',
    name: 'Mama Strong Fitness Studio',
    category: 'fitness',
    description: 'Women-only fitness studio with childcare included. Classes include yoga, HIIT, strength training, and barre. Supportive community of moms getting strong together.',
    location: 'Buford, GA',
    photos: [
      'https://readdy.ai/api/search-image?query=women%20doing%20yoga%20and%20fitness%20class%20in%20bright%20modern%20studio%20group%20exercise%20with%20mats%20and%20weights%20supportive%20community%20atmosphere&width=800&height=600&seq=fitness2a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=moms%20doing%20strength%20training%20and%20HIIT%20workout%20in%20fitness%20studio%20bright%20space%20with%20equipment%20active%20women%20exercising%20together&width=800&height=600&seq=fitness2b&orientation=landscape'
    ],
    website: 'https://mamastrongfitness.com',
    socialLinks: {
      instagram: 'https://instagram.com/mamastrongfitness',
      facebook: 'https://facebook.com/mamastrongstudio'
    },
    averageRating: 4.8,
    reviewCount: 39,
    reviews: [
      {
        reviewerName: 'Taylor S.',
        rating: 5,
        comment: 'The childcare is a game changer! I can actually focus on my workout. Great instructors too.',
        date: '2024-06-20'
      },
      {
        reviewerName: 'Lindsey K.',
        rating: 5,
        comment: 'Love the variety of classes and the supportive atmosphere. No judgment, just encouragement!',
        date: '2024-06-08'
      }
    ],
    isPartner: false,
    memberDiscount: ''
  },
  {
    id: 'fitness-3',
    name: 'Barre & Baby Fitness',
    category: 'fitness',
    description: 'Barre classes you can bring your baby to! Low-impact, high-intensity workout focusing on core strength and posture. Perfect for postpartum moms.',
    location: 'Suwanee, GA',
    photos: [
      'https://readdy.ai/api/search-image?query=moms%20doing%20barre%20workout%20with%20babies%20nearby%20bright%20studio%20with%20ballet%20barres%20women%20exercising%20with%20infants%20in%20carriers%20or%20on%20mats&width=800&height=600&seq=fitness3a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=women%20in%20barre%20fitness%20class%20at%20ballet%20barre%20bright%20studio%20with%20mirrors%20low-impact%20exercise%20group%20class&width=800&height=600&seq=fitness3b&orientation=landscape'
    ],
    website: 'https://barreandbaby.com',
    socialLinks: {
      instagram: 'https://instagram.com/barreandbaby',
      facebook: 'https://facebook.com/barreandbabyfitness'
    },
    averageRating: 4.7,
    reviewCount: 22,
    reviews: [
      {
        reviewerName: 'Olivia M.',
        rating: 5,
        comment: 'Perfect for new moms! I can bring my baby and still get a great workout.',
        date: '2024-06-16'
      },
      {
        reviewerName: 'Hannah P.',
        rating: 4,
        comment: 'Great postpartum workout. My core is getting stronger and baby loves watching!',
        date: '2024-06-04'
      }
    ],
    isPartner: true,
    memberDiscount: '20% off monthly membership'
  },
  {
    id: 'beauty-1',
    name: 'Blush & Blow Salon',
    category: 'hair-beauty',
    description: 'Full-service salon specializing in cuts, color, and styling. Complimentary beverages and relaxing atmosphere. Online booking available. Mom-friendly with flexible scheduling.',
    location: 'Sugar Hill, GA',
    photos: [
      'https://readdy.ai/api/search-image?query=modern%20bright%20hair%20salon%20interior%20with%20styling%20chairs%20and%20mirrors%20elegant%20beauty%20salon%20with%20comfortable%20seating%20and%20good%20lighting&width=800&height=600&seq=beauty1a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=woman%20getting%20hair%20styled%20and%20colored%20at%20salon%20professional%20hairstylist%20working%20beautiful%20results%20bright%20salon%20setting&width=800&height=600&seq=beauty1b&orientation=landscape'
    ],
    website: 'https://blushandblow.com',
    socialLinks: {
      instagram: 'https://instagram.com/blushandblow',
      facebook: 'https://facebook.com/blushblowsalon'
    },
    averageRating: 4.8,
    reviewCount: 56,
    reviews: [
      {
        reviewerName: 'Victoria R.',
        rating: 5,
        comment: 'My stylist is amazing! She always knows exactly what I want. Love this salon!',
        date: '2024-06-24'
      },
      {
        reviewerName: 'Chloe W.',
        rating: 5,
        comment: 'Great atmosphere and talented stylists. They work with my busy mom schedule.',
        date: '2024-06-11'
      },
      {
        reviewerName: 'Madison L.',
        rating: 4,
        comment: 'Beautiful salon and good service. Prices are a bit high but worth it for the quality.',
        date: '2024-05-29'
      }
    ],
    isPartner: true,
    memberDiscount: '15% off all services'
  },
  {
    id: 'beauty-2',
    name: 'Glow Skin Studio',
    category: 'hair-beauty',
    description: 'Skincare studio offering facials, waxing, and lash services. Custom treatments for all skin types. Licensed estheticians with years of experience.',
    location: 'Lawrenceville, GA',
    photos: [
      'https://readdy.ai/api/search-image?query=relaxing%20spa%20treatment%20room%20with%20massage%20table%20soft%20lighting%20and%20calming%20decor%20peaceful%20skincare%20studio%20atmosphere&width=800&height=600&seq=beauty2a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=woman%20receiving%20facial%20treatment%20at%20spa%20esthetician%20working%20with%20skincare%20products%20peaceful%20relaxing%20atmosphere&width=800&height=600&seq=beauty2b&orientation=landscape'
    ],
    website: 'https://glowskinstudio.com',
    socialLinks: {
      instagram: 'https://instagram.com/glowskinstudio',
      facebook: 'https://facebook.com/glowskinstudio'
    },
    averageRating: 4.9,
    reviewCount: 43,
    reviews: [
      {
        reviewerName: 'Sophia G.',
        rating: 5,
        comment: 'Best facials ever! My skin has never looked better. The esthetician is so knowledgeable.',
        date: '2024-06-19'
      },
      {
        reviewerName: 'Isabella T.',
        rating: 5,
        comment: 'So relaxing and my skin glows after every visit. Highly recommend!',
        date: '2024-06-07'
      }
    ],
    isPartner: false,
    memberDiscount: ''
  },
  {
    id: 'beauty-3',
    name: 'Polished Nail Lounge',
    category: 'hair-beauty',
    description: 'Upscale nail salon with luxury pedicure chairs and extensive polish selection. Sanitation is top priority. Walk-ins welcome but appointments recommended.',
    location: 'Buford, GA',
    photos: [
      'https://readdy.ai/api/search-image?query=elegant%20nail%20salon%20interior%20with%20luxury%20pedicure%20chairs%20and%20manicure%20stations%20bright%20clean%20modern%20space%20with%20polish%20displays&width=800&height=600&seq=beauty3a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=woman%20getting%20manicure%20at%20upscale%20nail%20salon%20beautiful%20nail%20art%20and%20polish%20colors%20professional%20nail%20technician%20working&width=800&height=600&seq=beauty3b&orientation=landscape'
    ],
    website: 'https://polishednaillounge.com',
    socialLinks: {
      instagram: 'https://instagram.com/polishednaillounge',
      facebook: 'https://facebook.com/polishednaillounge'
    },
    averageRating: 4.7,
    reviewCount: 38,
    reviews: [
      {
        reviewerName: 'Grace H.',
        rating: 5,
        comment: 'Clean, professional, and my nails always look perfect! Love the pedicure chairs.',
        date: '2024-06-21'
      },
      {
        reviewerName: 'Lily M.',
        rating: 4,
        comment: 'Great service and nice atmosphere. Can get busy on weekends so book ahead.',
        date: '2024-06-09'
      }
    ],
    isPartner: true,
    memberDiscount: '$10 off any service'
  },
  {
    id: 'tutor-1',
    name: 'Bright Minds Tutoring',
    category: 'tutors',
    description: 'One-on-one and small group tutoring for K-12 students. All subjects including math, reading, science, and test prep. Certified teachers with proven results.',
    location: 'Sugar Hill, GA',
    photos: [
      'https://readdy.ai/api/search-image?query=student%20working%20with%20tutor%20at%20desk%20bright%20learning%20environment%20books%20and%20educational%20materials%20one-on-one%20instruction%20focused%20studying&width=800&height=600&seq=tutor1a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=children%20in%20small%20group%20tutoring%20session%20with%20teacher%20bright%20classroom%20with%20learning%20materials%20engaged%20students%20studying%20together&width=800&height=600&seq=tutor1b&orientation=landscape'
    ],
    website: 'https://brightmindstutoring.com',
    socialLinks: {
      instagram: 'https://instagram.com/brightmindstutoring',
      facebook: 'https://facebook.com/brightmindstutoring'
    },
    averageRating: 4.9,
    reviewCount: 31,
    reviews: [
      {
        reviewerName: 'Diana K.',
        rating: 5,
        comment: 'My son\'s grades improved dramatically! The tutor is patient and really knows how to explain concepts.',
        date: '2024-06-17'
      },
      {
        reviewerName: 'Vanessa P.',
        rating: 5,
        comment: 'Excellent tutoring service. My daughter went from struggling to confident in math.',
        date: '2024-06-03'
      }
    ],
    isPartner: true,
    memberDiscount: 'First session free'
  },
  {
    id: 'tutor-2',
    name: 'Reading Rockets Literacy Center',
    category: 'tutors',
    description: 'Specialized reading intervention and literacy support. Phonics-based approach for struggling readers. Dyslexia screening and support available.',
    location: 'Suwanee, GA',
    photos: [
      'https://readdy.ai/api/search-image?query=child%20reading%20with%20tutor%20in%20bright%20colorful%20learning%20center%20books%20and%20literacy%20materials%20engaged%20student%20learning%20to%20read&width=800&height=600&seq=tutor2a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=reading%20intervention%20session%20with%20student%20and%20teacher%20phonics%20materials%20and%20books%20bright%20educational%20setting%20focused%20learning&width=800&height=600&seq=tutor2b&orientation=landscape'
    ],
    website: 'https://readingrockets.com',
    socialLinks: {
      instagram: 'https://instagram.com/readingrockets',
      facebook: 'https://facebook.com/readingrocketscenter'
    },
    averageRating: 5.0,
    reviewCount: 28,
    reviews: [
      {
        reviewerName: 'Brooke S.',
        rating: 5,
        comment: 'Life changing for our family! My son finally loves reading thanks to this program.',
        date: '2024-06-13'
      },
      {
        reviewerName: 'Paige L.',
        rating: 5,
        comment: 'Incredible results! The specialized approach really works for struggling readers.',
        date: '2024-05-31'
      }
    ],
    isPartner: false,
    memberDiscount: ''
  },
  {
    id: 'tutor-3',
    name: 'STEM Success Academy',
    category: 'tutors',
    description: 'Math and science tutoring with hands-on learning approach. Middle and high school focus. SAT/ACT test prep also available.',
    location: 'Buford, GA',
    photos: [
      'https://readdy.ai/api/search-image?query=students%20doing%20science%20experiments%20and%20math%20problems%20with%20tutor%20bright%20modern%20learning%20space%20STEM%20education%20materials&width=800&height=600&seq=tutor3a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=high%20school%20student%20working%20on%20math%20and%20science%20with%20tutor%20test%20prep%20materials%20and%20textbooks%20focused%20studying%20session&width=800&height=600&seq=tutor3b&orientation=landscape'
    ],
    website: 'https://stemsuccessacademy.com',
    socialLinks: {
      instagram: 'https://instagram.com/stemsuccessacademy',
      facebook: 'https://facebook.com/stemsuccessacademy'
    },
    averageRating: 4.8,
    reviewCount: 25,
    reviews: [
      {
        reviewerName: 'Kimberly F.',
        rating: 5,
        comment: 'My daughter\'s SAT math score went up 150 points! Excellent test prep.',
        date: '2024-06-15'
      },
      {
        reviewerName: 'Andrea M.',
        rating: 4,
        comment: 'Great for STEM subjects. My son finally understands chemistry!',
        date: '2024-06-01'
      }
    ],
    isPartner: true,
    memberDiscount: '10% off tutoring packages'
  },
  {
    id: 'doctor-1',
    name: 'Sugar Hill Pediatrics',
    category: 'doctors',
    description: 'Comprehensive pediatric care from newborn through adolescence. Same-day sick visits, well-child checkups, and immunizations. Accepting new patients.',
    location: 'Sugar Hill, GA',
    photos: [
      'https://readdy.ai/api/search-image?query=bright%20cheerful%20pediatric%20office%20with%20colorful%20decor%20and%20toys%20friendly%20waiting%20room%20for%20children%20medical%20clinic%20setting&width=800&height=600&seq=doctor1a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=pediatrician%20examining%20child%20in%20exam%20room%20friendly%20doctor%20with%20young%20patient%20bright%20clean%20medical%20office&width=800&height=600&seq=doctor1b&orientation=landscape'
    ],
    website: 'https://sugarhillpediatrics.com',
    socialLinks: {
      instagram: 'https://instagram.com/sugarhillpediatrics',
      facebook: 'https://facebook.com/sugarhillpediatrics'
    },
    averageRating: 4.9,
    reviewCount: 67,
    reviews: [
      {
        reviewerName: 'Caroline B.',
        rating: 5,
        comment: 'Dr. Smith is wonderful with kids! My children actually don\'t mind going to the doctor.',
        date: '2024-06-23'
      },
      {
        reviewerName: 'Julia R.',
        rating: 5,
        comment: 'Best pediatrician we\'ve had! Thorough, caring, and great with anxious kids.',
        date: '2024-06-11'
      },
      {
        reviewerName: 'Emma W.',
        rating: 5,
        comment: 'Love this practice! Easy to get appointments and the staff is so friendly.',
        date: '2024-05-27'
      }
    ],
    isPartner: false,
    memberDiscount: ''
  },
  {
    id: 'doctor-2',
    name: 'Gwinnett Family Dentistry',
    category: 'doctors',
    description: 'Family-friendly dental practice serving patients of all ages. Preventive care, cosmetic dentistry, and orthodontics. Kid-friendly environment with TVs in every room.',
    location: 'Lawrenceville, GA',
    photos: [
      'https://readdy.ai/api/search-image?query=modern%20bright%20dental%20office%20with%20comfortable%20chairs%20and%20friendly%20atmosphere%20family%20dentistry%20waiting%20room&width=800&height=600&seq=doctor2a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=child%20at%20dentist%20appointment%20friendly%20hygienist%20with%20young%20patient%20bright%20clean%20dental%20exam%20room%20with%20TV&width=800&height=600&seq=doctor2b&orientation=landscape'
    ],
    website: 'https://gwinnettfamilydentistry.com',
    socialLinks: {
      instagram: 'https://instagram.com/gwinnettfamilydentistry',
      facebook: 'https://facebook.com/gwinnettfamilydentistry'
    },
    averageRating: 4.8,
    reviewCount: 54,
    reviews: [
      {
        reviewerName: 'Alexis D.',
        rating: 5,
        comment: 'Great with kids! My son was nervous but the staff made him feel so comfortable.',
        date: '2024-06-18'
      },
      {
        reviewerName: 'Haley N.',
        rating: 5,
        comment: 'Whole family goes here. Professional, gentle, and the office is always clean.',
        date: '2024-06-06'
      }
    ],
    isPartner: true,
    memberDiscount: 'Free teeth whitening with new patient exam'
  },
  {
    id: 'doctor-3',
    name: 'Healthy Kids Urgent Care',
    category: 'doctors',
    description: 'Pediatric urgent care for non-emergency illnesses and injuries. Open evenings and weekends. No appointment needed. Shorter wait times than ER.',
    location: 'Buford, GA',
    photos: [
      'https://readdy.ai/api/search-image?query=pediatric%20urgent%20care%20clinic%20interior%20bright%20welcoming%20waiting%20area%20with%20toys%20and%20colorful%20decor%20medical%20facility%20for%20children&width=800&height=600&seq=doctor3a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=doctor%20treating%20child%20at%20urgent%20care%20clinic%20friendly%20medical%20staff%20with%20young%20patient%20bright%20clean%20exam%20room&width=800&height=600&seq=doctor3b&orientation=landscape'
    ],
    website: 'https://healthykidsurgentcare.com',
    socialLinks: {
      instagram: 'https://instagram.com/healthykidsurgentcare',
      facebook: 'https://facebook.com/healthykidsurgentcare'
    },
    averageRating: 4.7,
    reviewCount: 41,
    reviews: [
      {
        reviewerName: 'Marissa C.',
        rating: 5,
        comment: 'So convenient for weekend illnesses! Much better than waiting in the ER.',
        date: '2024-06-14'
      },
      {
        reviewerName: 'Kayla J.',
        rating: 4,
        comment: 'Quick service and kid-friendly. Great option when pediatrician is closed.',
        date: '2024-06-02'
      }
    ],
    isPartner: false,
    memberDiscount: ''
  },
  {
    id: 'vendor-1',
    name: 'Balloon Bliss Decor',
    category: 'party-vendors',
    description: 'Custom balloon installations and party decor. Balloon arches, columns, centerpieces, and more. Delivery and setup included. Perfect for birthdays, baby showers, and events.',
    location: 'Sugar Hill, GA',
    photos: [
      'https://readdy.ai/api/search-image?query=elaborate%20colorful%20balloon%20arch%20installation%20for%20party%20beautiful%20balloon%20decor%20with%20multiple%20colors%20festive%20celebration%20setup&width=800&height=600&seq=vendor1a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=birthday%20party%20decorated%20with%20balloon%20columns%20and%20centerpieces%20colorful%20festive%20balloon%20arrangements%20celebration%20decor&width=800&height=600&seq=vendor1b&orientation=landscape'
    ],
    website: 'https://balloonblissdecor.com',
    socialLinks: {
      instagram: 'https://instagram.com/balloonblissdecor',
      facebook: 'https://facebook.com/balloonblissdecor'
    },
    averageRating: 5.0,
    reviewCount: 48,
    reviews: [
      {
        reviewerName: 'Gabriella S.',
        rating: 5,
        comment: 'Absolutely stunning balloon arch for my daughter\'s birthday! Everyone was amazed!',
        date: '2024-06-20'
      },
      {
        reviewerName: 'Destiny M.',
        rating: 5,
        comment: 'Professional, creative, and on time. The balloon decor made the party perfect!',
        date: '2024-06-08'
      },
      {
        reviewerName: 'Savannah L.',
        rating: 5,
        comment: 'Worth every penny! The setup was gorgeous and lasted the entire party.',
        date: '2024-05-25'
      }
    ],
    isPartner: true,
    memberDiscount: '15% off all packages'
  },
  {
    id: 'vendor-2',
    name: 'Face Paint Fun',
    category: 'party-vendors',
    description: 'Professional face painting and temporary tattoos for parties and events. Kid-safe, hypoallergenic products. Experienced artists who work quickly and create amazing designs.',
    location: 'Suwanee, GA',
    photos: [
      'https://readdy.ai/api/search-image?query=children%20getting%20face%20painted%20at%20party%20colorful%20face%20paint%20designs%20happy%20kids%20with%20butterfly%20and%20superhero%20faces%20artist%20working&width=800&height=600&seq=vendor2a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=face%20painting%20artist%20with%20supplies%20and%20colorful%20designs%20professional%20face%20painter%20at%20kids%20party%20event%20bright%20cheerful%20setting&width=800&height=600&seq=vendor2b&orientation=landscape'
    ],
    website: 'https://facepaintfun.com',
    socialLinks: {
      instagram: 'https://instagram.com/facepaintfun',
      facebook: 'https://facebook.com/facepaintfun'
    },
    averageRating: 4.9,
    reviewCount: 36,
    reviews: [
      {
        reviewerName: 'Autumn H.',
        rating: 5,
        comment: 'The kids loved it! The artist was fast and the designs were incredible.',
        date: '2024-06-16'
      },
      {
        reviewerName: 'Skylar P.',
        rating: 5,
        comment: 'Huge hit at the party! Professional and the face paint didn\'t smudge.',
        date: '2024-06-04'
      }
    ],
    isPartner: false,
    memberDiscount: ''
  },
  {
    id: 'vendor-3',
    name: 'Sweet Treats Dessert Bar',
    category: 'party-vendors',
    description: 'Custom dessert tables and candy buffets for parties. Cupcakes, cookies, cake pops, and more. Beautiful displays that match your party theme.',
    location: 'Buford, GA',
    photos: [
      'https://readdy.ai/api/search-image?query=elaborate%20dessert%20table%20display%20with%20cupcakes%20cookies%20and%20candy%20colorful%20party%20treats%20beautiful%20arrangement%20themed%20dessert%20bar&width=800&height=600&seq=vendor3a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=candy%20buffet%20with%20jars%20of%20colorful%20sweets%20and%20treats%20party%20dessert%20display%20beautiful%20presentation%20festive%20setup&width=800&height=600&seq=vendor3b&orientation=landscape'
    ],
    website: 'https://sweettreatsbar.com',
    socialLinks: {
      instagram: 'https://instagram.com/sweettreatsbar',
      facebook: 'https://facebook.com/sweettreatsbar'
    },
    averageRating: 4.8,
    reviewCount: 32,
    reviews: [
      {
        reviewerName: 'Peyton K.',
        rating: 5,
        comment: 'The dessert table was the centerpiece of the party! Delicious and beautiful!',
        date: '2024-06-12'
      },
      {
        reviewerName: 'Addison R.',
        rating: 5,
        comment: 'Everything tasted as good as it looked! Highly recommend for parties.',
        date: '2024-05-30'
      }
    ],
    isPartner: true,
    memberDiscount: 'Free custom cookies with dessert table order'
  },
  {
    id: 'vendor-4',
    name: 'Party Princess Characters',
    category: 'party-vendors',
    description: 'Professional character performers for birthday parties. Princesses, superheroes, and more. Interactive entertainment including games, songs, and photo opportunities.',
    location: 'Lawrenceville, GA',
    photos: [
      'https://readdy.ai/api/search-image?query=princess%20character%20performer%20at%20kids%20birthday%20party%20beautiful%20costume%20entertaining%20children%20singing%20and%20playing%20games&width=800&height=600&seq=vendor4a&orientation=landscape',
      'https://readdy.ai/api/search-image?query=superhero%20character%20entertainer%20with%20children%20at%20party%20kids%20excited%20and%20happy%20professional%20costume%20performer&width=800&height=600&seq=vendor4b&orientation=landscape'
    ],
    website: 'https://partyprincesscharacters.com',
    socialLinks: {
      instagram: 'https://instagram.com/partyprincesscharacters',
      facebook: 'https://facebook.com/partyprincesscharacters'
    },
    averageRating: 5.0,
    reviewCount: 52,
    reviews: [
      {
        reviewerName: 'Mackenzie T.',
        rating: 5,
        comment: 'The princess was AMAZING! My daughter thought she was real. Best party ever!',
        date: '2024-06-19'
      },
      {
        reviewerName: 'Bailey W.',
        rating: 5,
        comment: 'Professional, punctual, and the kids were mesmerized. Worth every penny!',
        date: '2024-06-07'
      },
      {
        reviewerName: 'Kennedy M.',
        rating: 5,
        comment: 'Incredible entertainment! The character stayed in role the entire time.',
        date: '2024-05-24'
      }
    ],
    isPartner: true,
    memberDiscount: '$25 off character bookings'
  }
];